export default "__VITE_ASSET__be4292e9__"